// GroupSubscription
export const selectOptInGroups = state => state.subscription.optInGroups;
export const selectSelectedGroupIds = state => state.subscription.selectedGroupIds;

// AlertSubscription
export const selectNodisturb = state => state.subscription.optInGroups;
export const selectTimeZones = state => state.subscription.selectedGroupIds;
export const selectSubscriptions = state => state.subscription.selectedGroupIds;

// IncidentSubscription
export const selectMessage = state => state.subscription.message;
export const selectType = state => state.subscription.type;
export const selectData = state => state.subscription.resultData;
export const selectShouldShowIncidentSub = state => state.subscription.shouldShowIncidentSub;
export const selectCheckedShowIncidentSub = state => state.subscription.checkedShowIncidentSub;
